import { SansText } from '@velasca/ui/sans-text'
import type { SizeGuideTabButtonTextProps } from './SizeGuideTabButtonText.types'

export const SizeGuideTabButtonText = ({
  children,
}: SizeGuideTabButtonTextProps): JSX.Element => {
  return (
    <SansText
      uppercase
      padding="0.2rem 2rem"
      as="span"
      fontWeight="600"
      color="primary"
    >
      {children}
    </SansText>
  )
}
